import React from 'react';
import ProtectedRoute from '../../components/ProtectedRoute/ProtectedRoute';
import CaseQuizPage from '../../components/CaseStudy/CaseQuizPage';

const CaseQuizPageRoute = () => (
  <ProtectedRoute requiresAuth={true}>
    <CaseQuizPage />
  </ProtectedRoute>
);

export default CaseQuizPageRoute;
